import { useContentStore } from "@/stores/content";
import { defaultPropertyStep } from "../hardCodedValues";
import ModuleTemplate from "./moduleTemplate";
import { Path } from "../primitives";
import { ModuleProperty } from "../typeDefinations";
import { reactive, watch } from "vue";
import { ChannelPoint } from "../other";

export default class TeslaValve extends ModuleTemplate {
  id = "";
  channelDefs: Array<Array<ChannelPoint>> = [];
  properties: ModuleProperty = {
    channelWidth: {
      value: 400,
      name: "Channel Width",
      step: defaultPropertyStep,
      unit: "µm"
    },
    segPairNum: {
      value: 2,
      name: "Number of Segment Pairs",
      step: 1,
      unit: ""
    },
    segLenX: {
      value: 2000,
      name: "Segment Length",
      step: defaultPropertyStep,
      unit: "µm"
    },
    segLenY: {
      value: 1200,
      name: "Segment Width",
      step: defaultPropertyStep,
      unit: "µm"
    },
    height: {
      value: 400,
      name: "Module Height",
      step: defaultPropertyStep,
      unit: "µm"
    },
    reflowRadius: {
      value: 0,
      name: "Reflow Radius",
      step: defaultPropertyStep,
      unit: "µm"
    }
  };

  get getModuleIndex(): number {
    return 3;
  }
  get numberOfChannelPorts(): number {
    return 2;
  }
  get portSizeFixed(): boolean {
    return false;
  }

  clone(): TeslaValve {
    const copy = new TeslaValve(this.position, this.layer, this.rotation);
    copy.properties.channelWidth.value = this.properties.channelWidth.value;
    copy.properties.segPairNum.value = this.properties.segPairNum.value;
    copy.properties.segLenX.value = this.properties.segLenX.value;
    copy.properties.height.value = this.properties.height.value;
    copy.properties.segLenY.value = this.properties.segLenY.value;
    copy.properties.reflowRadius.value = this.properties.reflowRadius.value;
    copy.updateRender();
    return copy;
  }
  setNewModuleId(): void {
    TeslaValve.count++;
    const contentStore = useContentStore();
    while (contentStore.contentMap.has("TeslaValve-" + TeslaValve.count)) {
      TeslaValve.count++;
    }
    this.id = "TeslaValve-" + TeslaValve.count;
  }

  updatePortHelper(): void {
    this.channelPorts[0].position[0] = this.position[0];
    this.channelPorts[0].position[1] = this.position[1];
    this.channelPorts[1].position[0] =
      this.position[0] +
      this.properties.segLenX.value * this.properties.segPairNum.value * 2 +
      this.properties.segLenY.value / 2;
    this.channelPorts[1].position[1] = this.position[1];

    if (this.rotation != 0) {
      const r = this.rotation;
      this.rotation = 0;
      this.setRotation(r);
    }
  }
  updateRender(): void {
    this.elementsToRender.topLeftCorner = [
      this.position[0],
      this.position[1] - this.properties.segLenY.value
    ];
    this.elementsToRender.centerPoint = [
      this.position[0] +
        this.properties.segLenX.value * this.properties.segPairNum.value +
        this.properties.segLenY.value / 4,
      this.position[1]
    ];

    const r = this.properties.segLenY.value / 2;

    let pathDef = `M${this.position[0]} ${this.position[1]}`;
    const rep = `l${this.properties.segLenX.value} ${-r} a${r} ${r} 0 0 1 0 ${
      this.properties.segLenY.value
    } m${-this.properties.segLenX.value} ${-r} l${
      this.properties.segLenX.value * 2
    } ${this.properties.segLenY.value} a${r} ${r} 0 0 0 0 ${-this.properties
      .segLenY.value} m${-this.properties.segLenX.value} ${r} l${
      this.properties.segLenX.value
    } ${-r}`;
    pathDef += rep.repeat(this.properties.segPairNum.value);
    pathDef += `l${r} 0`;

    this.elementsToRender.borderShapes = [
      new Path(pathDef, this.properties.channelWidth.value, false, this.properties.reflowRadius.value, "TeslaValve")
    ];
    this.updatePort();
  }

  updatePositionWithChannelDefs(x: number, y: number): void {
    const offsetX = x - this.translate[0];
    const offsetY = y - this.translate[1];
    // somehow the first channelDef with valve can update the position unlike the others, thats why we leave the first one out 
    // and only update the others
    let first = true;
    this.channelDefs.forEach((p) => {
      let index = 0;
        
      p.forEach((point) => {
        if (!point.isConnectedToPort) {
         point.position[0] += offsetX;
          point.position[1] += offsetY;
        }
        if (index === 0) {
          point.valves.forEach((v) => {
            if (first) {
              first = false;
              v.updatePort();
            } else {
              v.channelSegment.start.position[0] += offsetX;
              v.channelSegment.start.position[1] += offsetY;
              v.channelSegment.end.position[0] += offsetX;
              v.channelSegment.end.position[1] += offsetY;
              v.updatePort();
            }
              
          });
        }   index++;
      });
    });
    this.setTranslate(x, y);
  }

  constructor(pos: number[], layer: string, rotation = 0) {
    super(pos, layer, rotation);
    this.properties = reactive(this.properties);
    this.setupWatcher();
  }

  setupWatcher(): void {
    watch(() => this.properties, () => {
      const minVal = Math.min(this.properties.channelWidth.value, this.properties.height.value);
      if (2 * this.properties.reflowRadius.value > minVal) {
        console.log("Reflow Radius is too large, setting it to the maximum possible (half of the minimum value of Channel Width and Height)");
        this.properties.reflowRadius.value = minVal / 2;
      }
    }, {
      deep: true 
    });
  }
}
